import React, { useState, useEffect, useRef } from 'react';
import Export from "../../../assets/images/export.svg";
import Arcv from "../../../assets/images/archive.svg";
import Activ from "../../../assets/images/active.svg";
import { Button, Modal, Form, Tabs, Tab, InputGroup } from 'react-bootstrap';
import pen from "../../../assets/images/pen.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faPencil } from '@fortawesome/free-solid-svg-icons';
import DownloadGrid from './common/DownloadGrid.js';
import { withDVRToken, withRFSToken } from '../../../Services/axios.js';
import info from "../../../assets/images/info.png";
import { toast } from 'react-toastify';
import ConfModal from '../../../Components/common/ConfModal.js';
import { getTodayDateTime, applyOffsetToDateTime, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import axios from 'axios';
import Select from 'react-select';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import phonePrefixes from '../../../Utils/phonePrefixes.json';
import { LogOut } from '../../Auth/LogOut.js';

const Visitor = () => {

    const isMounted = useRef(false);
    const inputRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState({ Active: [], Archived: [], });
    const [gridSelect, setGridSelect] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const [activeTab, setActiveTab] = useState('Active');
    const [downloadModal, setDownloadModal] = useState(false);
    const closeDownloadModal = () => setDownloadModal(false);
    const openDownloadModal = () => setDownloadModal(true);

    const [editModal, setEditModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedField, setSelectedField] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [dateTimeValue, setDateTimeValue] = useState("");

    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const [disLoading, setDisLoading] = useState(false);
    const [addVisitorModal,setAddVisitorModal] = useState(false)
    const [loadingType, setLoadingType] = useState();
    const [modalMessage, setModalMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [dialCode, setDialCode] = useState();
    const sigPadRef = useRef(null);
    const [view, setView] = useState("menu");
    const [searchText, setSearchText] = useState("");
    const [userList, setUserList] = useState([]);
    const [signatureMode, setSignatureMode] = useState("draw");
    const [typedSignature, setTypedSignature] = useState("");

    const [visitorForm, setVisitorForm] = useState({
        visitor_name: "",
        surname: "",
        company_name: "",
        license: "",
        person_to_meet: "",
        arrived_with_car: "",
        status: "1",
    });

    const phoneOptions = (phonePrefixes).map(p => ({
        value: p.dialCode,
        label: `${p.dialCode} - ${p.isoCode}`,
        isoCode: p.isoCode
    }))

  const resetVisitorForm = () => {
    setVisitorForm({
        visitor_name: "",
        surname: "",
        company_name: "",
        license: "",
        person_to_meet: "",
        arrived_with_car: "",
        status: "1",
    });
    setDialCode("");
    setSignatureMode("draw");
    setTypedSignature("");
    if (sigPadRef.current)
         sigPadRef.current.clear();
    };

    useEffect(() => {
        const interval = setInterval(() => {
            window.location.reload();
        }, 300000);
        if (!isMounted.current) {
            fetchSettings();
            setIsLoading(false);
            setGridData([]);
            isMounted.current = true;
        }
        return () => clearInterval(interval);

    }, []);

    const filterPhoneOption = (candidate, rawInput) => {
        const input = (rawInput || '').trim();
        if (!input) return true;
        const digits = input.replace(/\D/g, '');
        const label = candidate.label.toLowerCase();
        const iso = (candidate.data?.isoCode || '').toLowerCase();
        // If user typed numbers → match dial code digits
        if (digits) {
        const optionDigits = String(candidate.value).replace(/\D/g, '');
        return optionDigits.includes(digits);
        }
        // Else match iso code or label text
        return iso.includes(input.toLowerCase()) || label.includes(input.toLowerCase());
  };

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };

    let checkUlds = [];
    useEffect(() => {

        if (gridRefs[activeTab].current) {

            // var token = "Bearer " + localStorage.DVR;
            jqxCookieCall();
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}vehicle-management/list-visitors?tab=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'first_name', type: 'string' },
                    { name: 'number', type: 'string' },
                    { name: 'company_name', type: 'string' },
                    { name: 'arrived_with_car', type: 'string' },
                    { name: 'license', type: 'string' },
                    { name: 'person_to_meet', type: 'string' },
                    { name: 'signature_text', type: 'string' },
                    { name: 'attachments', type: 'string' },
                    { name: 'created_at', type: 'string' },
                    { name: 'checkout_date', type: 'string' },
                ],
                filter: function (allfilters) {
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    setGridSelect([]);

                    if (allfilters.length > 0) {
                        console.log("Filter Applied");
                        setFilterApplied(true);
                    } else {
                        console.log("Filter Cleared");
                        setFilterApplied(false);
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'First Name', datafield: 'first_name', width: '12%' },
                // { text: 'Telephone', datafield: 'number', width: '10%', hidden: activeTab !== 'Active', },
                { text: 'Company Name', datafield: 'company_name', width: '12%' },
                { text: 'Car', datafield: 'arrived_with_car', width: '6%' },
                { text: 'License Plate No', datafield: 'license', width: '10%' },
                { text: 'Person to Meet', datafield: 'person_to_meet', width: '12%' },
                {
                    text: 'Date time In',
                    datafield: 'created_at',
                    width: '10%',
                    cellsrenderer: function (row, columnfield, value) {
                        const formatted = applyOffsetToDateTime(value , "L");
                        return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${formatted}</div>`;
                    }
                },
                {
                    text: 'Date Time Out',
                    datafield: 'checkout_date',
                    width: '10%',
                    cellsrenderer: function (row, columnfield, value, defaultHtml) {
                        // if (!value) {
                        //     return `<div class="set_fn" data-field="checkout_date" >
                        //         <img src="${pen}" class="row_edit" /> Set
                        //     </div>`;
                        // }

                        const date = new Date(value);
                        const formatted = date.toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false
                        });
                        if (value) {
                            defaultHtml = '<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">' + value + '<span class="screen" data-field="checkout_date"><img src="' + pen + '" class="" /></span></div>';
                        } else {
                            defaultHtml = '<div class="set_fn " data-type="add" data-for="get_in"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
                        }
                        return (
                            defaultHtml
                        );
                    }
                },
                {
                    text: 'Signature',
                    datafield: 'signature_text',
                    width: '8%',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;"><img class="signature-info-icon"  src="${info}" /></div>`;
                    }
                }
            ];



            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                height: 1040,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: 'checkbox', // checkbox
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },

            };

            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                // console.log('event', args)
                if (event.args.columnindex > -1) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.signature-info-icon', function () {
                setShowModal(true)
            });
            window.$(gridRefs[activeTab].current).on('click', '.set_fn,.screen', function () {
                const field = window.$(this).attr("data-field");
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

                setSelectedField(field);
                setSelectedRow(rowData);
                if (rowData && rowData[field]) {
                    setDateTimeValue(rowData[field])
                } else {
                    setDateTimeValue(getTodayDateTime());
                }

                setEditModal(true);
            });

            // }
        }
    }, [gridData]);

    const [linkModal, setLinkModal] = useState(false);
    let token = localStorage.DVR;
    const [dvLink, setDvLink] = useState('');
    const [originalLink, setOriginalLink] = useState('');
    const [bothAccess, setBothAccess] = useState(false);

    const updatePersonInUrl = (link, personValue) => {
        try {
            const urlObj = new URL(link);
            urlObj.searchParams.set('person', personValue);
            return urlObj.toString();
        } catch (e) {
            return link;
        }
    }
    const openModal = async () => {

        try {
            const res = await withRFSToken.post('vehicle-management/generate-link', { type: 'Visitor' });
            if (res.data.response_code === 200) {
                const innerData = res?.data?.response_data;
                setDvLink(innerData?.link)
                setOriginalLink(innerData?.link)
                setBothAccess(false)
                setLinkModal(true);
            } else {
                toast.error(res.data.response_msg)
            }

        } catch (error) {
            console.error('Error fetching settings:', error);
            // toast.error('Failed to load settings');
        }
    }
    const closeConfirm = () => {
        setLinkModal(false);
    }


    const handleCopy = () => {
        if (inputRef.current) {
            inputRef.current.select();
            inputRef.current.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(inputRef.current.value);
            //   console.log("Copied: " + inputRef.current.value);
        }
    };

    const saveDateTime = async () => {

        try {
            const token = "Bearer " + localStorage.DVR;
            const payload = {
                id: selectedRow.id,
                type: "Visitor",
            };
            if (selectedField === "checkin_date") {
                payload.checkin_date = formatDateTime(dateTimeValue);
            } else {
                payload.checkout_date = formatDateTime(dateTimeValue);
            }
            const res = await withRFSToken.post('vehicle-management/set-checkout-in-time', payload);
            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
            setEditModal(false);
        } catch (error) {
            console.error("Save Failed:", error.response?.data || error.message);
            alert("Failed to update. Please try again.");
        }
    };

    const formatDateTime = (value) => {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const activateLink = () => {
        const url = inputRef.current.value;
        // const logoutUrl = localStorage.getItem('LogOut');

        if (url) {
            window.open(
                url,
                '_blank', // always opens in a new tab/window
                'noopener,noreferrer,width=1000,height=800' // optional features
            );
        }
        localStorage.clear();
        // window.location.replace(logoutUrl);
        LogOut()
    };

     const regenerateLink = async () => {
            try {
                setDisLoading(true);
                const res = await withRFSToken.post('vehicle-management/generate-org-passcode', { type: 'Visitor' });
                if (res.data.response_code === 200) {
                    const innerData = res?.data?.response_data;
                    setDvLink(innerData?.link);
                    setOriginalLink(innerData?.passcode);
                    toast.success('Passcode regenerated successfully');
                } else {
                    toast.error(res.data.response_msg);
                }
            } catch (error) {
                console.error('Error regenerating link:', error);
                toast.error('Failed to regenerate passcode');
            } finally {
                setDisLoading(false);
                // setLinkModal(false);
            }
        };

    const handleRegenerateConfirm = () => {
        setConfData({
            header: "Regenerate Passcode",
            subHeader: "Are you sure you want to regenerate the passcode?",
            primaryBtn: "Yes",
            secondaryBtn: "No",
            modalConf: regenerateLink,
        });
        setModalConf(true);
    };

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    };

    const handleMoveToActArc = () => {
        if (!gridSelect.length) {
            toast.error('Please select row first');
            return;
        }
        setConfData({
            header: `Selected Data move to ${activeTab == 'Active' ? 'Archive' : 'Active'}`,
            subHeader: `'Are you sure you want to ${activeTab == 'Active' ? 'Archive' : 'Active'}?`,
            primaryBtn: 'Confirm',
            secondaryBtn: 'Cancel',
            modalConf: tabChangeConf,
        })
        setModalConf(true);
    }
    const tabChangeConf = async () => {
        const payload = {
            tab: 'Visitor',
            id: gridSelect.map(op => op.id),
            status: activeTab == 'Active' ? 0 : 1
        }
        // console.log("🚀 ~ tabChangeConf ~ payload:", payload)
        try {
            const res = await withRFSToken.post('vehicle-management/update-activity-status', payload);
            const innerData = res?.data?.response_data;
            if (res.data.response_code === 200) {
                setModalConf(false);
                 gridSelect.forEach(item => {
                    const selectedRowBoundIndex = item.boundindex;
                    window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                });
                setGridSelect([])
                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            } else {
                toast.error(res.data.response_msg)
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    }
    const confModalClose = () => {
        setModalConf(false);
    }
        const openVisitorModal = () =>{
        setAddVisitorModal(true)
    }

        const closeVisitorConfirm = () =>{
        setAddVisitorModal(false)
    }

          const handleVisitorChange = (e) => {
    const { name, value } = e.target;
    setVisitorForm((prev) => ({ ...prev, [name]: value }));
  };

  const visitorFields = [
    { label: 'Company', type: 'text', name: 'company_name', ph: 'Company name' },
    { label: 'Visitor Name', type: 'text', name: 'visitor_name', ph: 'Visitor name' },
    // { label: 'Phone No.', type: 'tel', name: 'number', ph: 'Phone No.' },
  ];

  const validateVisitorForm = () => {
    if (!visitorForm.visitor_name?.trim()) {
        toast.error("Visitor Name is required");
        return false;
    }
    if (!visitorForm.company_name?.trim()) {
        toast.error("Company Name is required");
        return false;
    }
    if (!visitorForm.arrived_with_car) {
        toast.error("Please select if arrived by car");
        return false;
    }
    if (visitorForm.arrived_with_car === "Yes" && !visitorForm.license?.trim()) {
        toast.error("License Plate No. is required");
        return false;
    }
    return true;
    };

  const handleVisitorSubmit = async () => {
    if (!validateVisitorForm()) return;
  try {
    const payload = {
      ...visitorForm
    };
    const res = await withRFSToken.post(`${process.env.REACT_APP_RFS_URL}vehicle-management/save-visitor`,payload);    
    if (res.data?.response_code === 200) {
      const msg = res.data?.response_msg ||"Driver saved successfully!";
      toast.success(msg);
      resetVisitorForm();
      setAddVisitorModal(false); 
      window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata'); 
    } else {
      const msg = res.data?.response_msg || "Error saving visitor";
      toast.error(msg);
      console.warn("Visitor save business error:", res.data);
    }
  } catch (err) {
    console.error("Visitor save error:", err.response?.data || err.message);
    toast.error("Error saving visitor");
  } finally {
    setLoading(false);
    setAddVisitorModal(false); 
  }
};

  const handleOnSelect = async (item) => {
    setVisitorForm((prev) => ({ ...prev, 'person_to_meet': item.name, 'appointment_with': item.id }));
  }

    const fetchSettings = async () => {
      try {
        const res = await withRFSToken.get('get-authorize-user');
        const innerData = res?.data?.response_data;
        const trData = innerData.map(dta => ({ id: dta.value, name: dta.label }))
        setUserList(innerData || [])
      } catch (error) {
        console.error('Error fetching settings:', error);
        // toast.error('Failed to load settings');
      }
    };
    return ( 
        <>
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={confModalClose}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            {/* <div className="">
                <Header page_type='fdvr' logo_url='/DVRegistration/Visitor' />
                <div className="page-body-wrapper schedule"> */}
                    {/* <LeftMenu /> */}
                    {/* <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='DVR' />
                            <div className="lcontent"> */}
                                <div className="mb-1 nestedtabs rounded minh">
                                    <div className='d-flex'>
                                        <button className="addtruck me-2" variant="primary" onClick={openModal}>
                                            <span>Generate Link</span>
                                        </button>

                                        <button className="addtruck me-2" variant="primary" onClick={openVisitorModal}>
                                            <span> <FontAwesomeIcon icon={faPlus} /> Add Visitor</span>
                                        </button>
                                        <div className='ulddown'>
                                            <button onClick={handleMoveToActArc}> <img title='' src={activeTab == 'Active' ? Arcv : Activ} /> {activeTab == 'Active' ? 'Archive' : 'Active'} </button>
                                            <button className="addtruck me-2" variant="primary" onClick={openDownloadModal}><img src={Export} /> Download</button>
                                        </div>
                                    </div>
                                </div>
                                <div className='maindiv'>
                                    <div className='trashdonload'>
                                        {/* {!isLoading && <div ref={gridRefs[activeTab]} className='bookinggrid' ></div>} */}
                                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                                            <Tab eventKey="Active" title={<span> Active </span>} className='moveto'>
                                                {!isLoading && <>
                                                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                    <div ref={gridRefs.Active} className='bookinggrid' ></div>
                                                </>
                                                }
                                            </Tab>
                                            <Tab eventKey="Archived" title={<span>Archived </span>} className='moveto'>
                                                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                                            </Tab>
                                        </Tabs>
                                    </div>
                                </div>
                            {/* </div>
                        </div>
                    </div>
                </div> */}
                <Modal show={linkModal} onHide={closeConfirm} className="addfrom change_type" centered>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <h3>Generate Link</h3>
                        { dvLink && <><Form.Label>Link</Form.Label>
                        <div className='d-flex'>
                            <Form.Control
                                type="text"
                                ref={inputRef}
                                name="link"
                                value={dvLink || ''}
                                readOnly
                            />
                            <Button onClick={handleCopy}>Copy</Button>
                        </div></> }
                        {/* <Form.Check
                            className='mt-2'
                            type='checkbox'
                            id='both-access'
                            label='Allow access to both'
                            checked={bothAccess}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setBothAccess(checked);
                                if (checked) {
                                    setDvLink(prev => updatePersonInUrl(originalLink || prev, 'B'))
                                } else {
                                    setDvLink(originalLink || dvLink)
                                }
                            }}
                        /> */}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex w-50 mx-auto are_bottom">
                            <Button variant="secondary" onClick={closeConfirm}> Cancel </Button>
                            <Button variant="primary" onClick={activateLink}> Activate </Button>
                            {/* <Button variant="primary" onClick={handleRegenerateConfirm}>  {dvLink ? "Regenerate" : "Generate"} </Button> */}
                        </div>
                    </Modal.Footer>
                </Modal>


                <Modal show = {addVisitorModal} onHide={closeVisitorConfirm} className="addfrom change_type" centered>
                                   <Modal.Header closeButton></Modal.Header>
                                    <Modal.Body>
                                        <h3>Visitor Registration</h3>
                                        <p className='visitor_text'>Please share your details to complete visitor registration</p>
                                    <div>
                                        <Form>
                {visitorFields.map((frm, index) => (
                  <Form.Group className="mb-3" key={`v_${index}`}>
                    <Form.Label>{frm.label} <span className="text-danger">*</span></Form.Label> 
                    {frm.name === 'number' ? (
                      <InputGroup>
                        <div className='phone_code' style={{ width: '40%' }}>
                          <Select
                            options={phoneOptions}
                            filterOption={filterPhoneOption}
                            placeholder="Code"
                            value={phoneOptions.find(o => o.value === dialCode) || null}
                            onChange={(opt) => {
                              const newCode = opt ? opt.value : '';
                              setDialCode(newCode);
                              const local = visitorForm.number ? (visitorForm.number.split('-')[1] || '') : '';
                              setVisitorForm(prev => ({ ...prev, number: newCode ? `${newCode}-${local}` : local }));
                            }}
                            isClearable
                          />
                        </div>
                        <Form.Control
                          type="tel"
                          name={frm.name}
                          value={visitorForm.number ? (visitorForm.number.split('-')[1] || '') : ''}
                          onChange={(e) => {
                            const local = e.target.value;
                            const code = dialCode || '';
                            setVisitorForm(prev => ({ ...prev, number: code ? `${code}-${local}` : local }));
                          }}
                          placeholder={frm.ph}
                          inputMode="numeric"
                          style={{ borderRadius: '8px' }}
                        />
                      </InputGroup>
                    ) : (
                      <Form.Control
                        type={frm.type}
                        name={frm.name}
                        value={visitorForm[frm.name]}
                        onChange={handleVisitorChange}
                        placeholder={frm.ph}
                        style={{ borderRadius: '8px' }}
                      />
                    )}
                  </Form.Group>
                ))}
                <Form.Group className="mb-3">
                  <Form.Label>Appointment With</Form.Label>
                  {/* <Select
                    options={userList}
                    onChange={(selected) => {
                      const updatedData = { ...visitorForm, person_to_meet: selected.value };
                      setVisitorForm(updatedData);
                    }}
                    placeholder="Select"
                    className=''
                    filterOption={customFilter}
                    isClearable
                    menuIsOpen={undefined}
                    name="person_to_meet"
                    value={userList.find(option => option.value === visitorForm.person_to_meet)}
                  /> */}
                   <div className={searchText.length < 3 ? "hide-no-results" : ""}>
                    <style>
                      {`
                        .hide-no-results .sc-gEvEer.ffXrxx {
                          display: none !important;
                        }
                      `}
                    </style>
                  <ReactSearchAutocomplete
                    items={userList}
                    onSelect={handleOnSelect}
                    onSearch={(string) => {
                        setSearchText(string);
                    }}
                    autoFocus
                    placeholder="Appointment With"
                    fuseOptions={{
                      shouldSort: true,
                      threshold: 0.0, // exact match required at start
                      location: 0,    // start of string
                      distance: 0,
                      minMatchCharLength: 3,
                      keys: ["name"]
                    }}
                    styling={{
                    resultsContainer: {
                      backgroundColor: "#fff",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      zIndex: 9999
                    },
                    resultItem: {
                      padding: "10px",
                      cursor: "pointer"
                    },
                    resultItemHover: {
                      backgroundColor: "#f0f0f0"
                    }
                  }}
                  />
                  </div>
                  {/* <Form.Control
                  type="text"
                  name="person_to_meet"
                  value={visitorForm.person_to_meet}
                  onChange={handleVisitorChange}
                  placeholder="Appointment with"
                /> */}
                </Form.Group>
                {/* <Form.Group className="mb-3">
                  <Form.Label>Visitor Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="visitor_name"
                    value={visitorForm.visitor_name}
                    onChange={handleVisitorChange}
                    placeholder="Visitor name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Company</Form.Label>
                  <Form.Control
                    type="text"
                    name="company_name"
                    value={visitorForm.company_name}
                    onChange={handleVisitorChange}
                    placeholder="Company name"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>License Plate No.</Form.Label>
                  <Form.Control
                    type="text"
                    name="license"
                    value={visitorForm.license}
                    onChange={handleVisitorChange}
                    placeholder="License plate no."
                  />
                </Form.Group> */}
                <Form.Group className="mb-3 sl_status">
                  <Form.Label>Arrived by Car <span className="text-danger">*</span></Form.Label>
                  <div className='radio-card-group'>
                    <Form.Check
                      inline
                      label="Yes"
                      type="radio"
                      id="arrived_yes"
                      value="Yes"
                      name="arrived_with_car"
                      checked={visitorForm.arrived_with_car === "Yes"}
                      onChange={(e) =>
                        setVisitorForm((prev) => ({
                          ...prev,
                          arrived_with_car: e.target.value,
                        }))
                      }
                    />
                    <Form.Check
                      inline
                      label="No"
                      type="radio"
                      id="arrived_no"
                      value="No"
                      name="arrived_with_car"
                      checked={visitorForm.arrived_with_car === "No"}
                      onChange={(e) =>
                        setVisitorForm((prev) => ({
                          ...prev,
                          arrived_with_car: e.target.value,
                          license: "", // clear license if "No"
                        }))
                      }
                    />
                  </div>
                </Form.Group>



                {visitorForm.arrived_with_car === "Yes" && (
                  <Form.Group className="mb-3">
                    <Form.Label>License Plate No. <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="license"
                      value={visitorForm.license}
                      onChange={handleVisitorChange}
                      placeholder="License plate no."
                    />
                  </Form.Group>
                )}

                {/* Signature */}
                {/* <Form.Group className="mb-3">
                  <Form.Label>Signature</Form.Label>
                  {signatureMode === "draw" ? (
                    <div style={{ border: "1px solid #ddd", borderRadius: "8px", background: "#f9f9f9", }}>

                      <SignatureCanvas ref={sigPadRef} penColor="black" canvasProps={{ width: 420, height: 150, className: "sigCanvas", }} />
                      <Button size="sm" variant="light" className="mt-2" onClick={() => sigPadRef.current.clear()}>
                        <FontAwesomeIcon icon={faEraser} />
                      </Button>
                    </div>
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder="Type your signature"
                      className="type_sign"
                      value={typedSignature}
                      onChange={(e) =>
                        setTypedSignature(e.target.value)}
                    />
                  )}
                  <Row className="mt-3">
                    <Col>
                      <Button
                        variant={
                          signatureMode === "draw"
                            ? "secondary"
                            : "outline-secondary"
                        }
                        size="sm"
                        className="w-100 loading_unloading_btn"
                        onClick={() => setSignatureMode("draw")}
                      >
                        Draw Signature
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant={
                          signatureMode === "type"
                            ? "secondary"
                            : "outline-secondary"
                        }
                        size="sm"
                        className="w-100 loading_unloading_btn"
                        onClick={() => setSignatureMode("type")}
                      >
                        Typing Signature
                      </Button>
                    </Col>
                  </Row>
                </Form.Group> */}
                {/* Buttons */}
                            <div className="submit_cancel_btn">
                                <div className="d-flex" style={{ gap: "10px" }}>
                                    <Button onClick={handleVisitorSubmit} variant="primary" className="w-100 mt-0">
                                        Submit
                                    </Button>
                                </div>
                            </div>
              </Form>
                                    </div>
                                    </Modal.Body>
                </Modal>


                {disLoading &&
                    <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}>
                        <span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span>
                    </div>
                }
                {downloadModal && (
                    <DownloadGrid onClose={closeDownloadModal} tabName={'Visitor'} />
                )}
                <Modal show={editModal} onHide={() => setEditModal(false)} centered className="addfrom change_type">
                    <Modal.Header closeButton>
                        <Modal.Title>Edit {selectedField === "checkin_date" ? "Date Time In" : "Date Time Out"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>Select Date & Time</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                value={dateTimeValue}
                                onChange={(e) => setDateTimeValue(e.target.value)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={saveDateTime}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    className="addfrom change_type"
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    centered
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <h3>Signature Info</h3>
                        <p className='mb-3'>To View This Signature. <br /> Please Contact Cargohub <b>Support Team</b></p>
                    </Modal.Body>
                </Modal>
            {/* </div> */}
        </>
    )
}

export default Visitor